import React from "react";
import { PlusOutlined , PrinterOutlined } from "@ant-design/icons";
import {
  Drawer,
  Button,
  PageHeader,
} from "antd";
import { useState } from "react";



import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import DrawableCloseIcon from "../../components/common/DrawableCloseIcon";
import { DEFAULT_MASTER_DRAWER_WIDTH } from "../../utility/Constants";
import HolidayEntry from "../../components/masters/holiday/HolidayEntry";
import HolidayList from "../../components/masters/holiday/HolidayList";
import commonUtility from "../../utility/Utils";
import { HOLIDAY_LIST_PRINT_URL } from "../../utility/URL";


const Holiday = () => {
  const [visible, setVisible] = useState(false);
  const [holidayAddData, setHolidayAddData] = useState({
    holiday_id: 0,
    type:'',
    holiday_date: '',
    holiday_description: '',
    tap_group:'',
    mode: "ADD"
  });

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };
  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Holiday"
          subTitle=""
          extra={[
            <Button key="1" className="custom-button-white" shape="round" onClick={showDrawer}>
              <PlusOutlined /> Add
            </Button>,
            <Button key="2" className="custom-button-white" shape="round" onClick={() => commonUtility.openInNewTab(`${HOLIDAY_LIST_PRINT_URL}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`)}>
              <PrinterOutlined /> Print
            </Button>,
          ]}
        ></PageHeader>

        <Drawer
          title="Add new holiday"
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose={true}
          closeIcon = {<><DrawableCloseIcon /></>}
        >
          <HolidayEntry data={holidayAddData} onDrawerClose={onClose}  />
        </Drawer>

          <div className="tableView">
        <div className="form-content">
          {/* <TimeSlotList /> */}
          <HolidayList />
        </div>
        </div>

      </div>
    </div>
  );
};

export default Holiday;
